<template>
  <div>
    <div>
      <div>
        <UpdateProfileInformationForm :user="user"/>

        <JetSectionBorder/>
      </div>

      <div>
        <SendPasswordResetMailForm :user="user" class="mt-10 sm:mt-0"/>
        <JetSectionBorder/>
      </div>

      <div>
        <jet-secondary-button type="button" @click.prevent="reset2Fa">
          {{ $t('Reset two-factor authentication') }}
        </jet-secondary-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetSectionBorder from '@/Jetstream/SectionBorder.vue';
import UpdateProfileInformationForm from '@/Components/UserProfile/Partials/UpdateProfileInformationForm.vue';
import SendPasswordResetMailForm from "./Partials/SendPasswordResetMailForm.vue";

export default {
  name: "UserMasterDataManager",
  components: {
    SendPasswordResetMailForm,
    Link,
    JetSecondaryButton,
    JetSectionBorder,
    UpdateProfileInformationForm,
  },
  props: {
    user: Object,
  },
  computed: {},
  data() {
    return {
      form: this.$inertia.form({
        salutation_id: this.user.salutation_id ? this.user.salutation_id : null,
        name: this.user.name ? this.user.name : null,
        email: this.user.email ? this.user.email : null,
        additional_email: this.user.additional_email ? this.user.additional_email : null,
      }),
    };
  },
  methods: {
    reset2Fa() {
      this.$inertia.post(
          route('user.2fa.reset'),
          {user_id: this.user.id},
          {
            preserveScroll: true,
            preserveState: false,
            onSuccess: () => {

            },
          }
      );
    },
  },
}
</script>

<style scoped>

</style>
